import * as React from 'react';
import {Link} from 'react-router-dom';

import get from 'lodash/get';
import _ from 'underscore';
// @ts-expect-error
import startsWith from 'underscore.string/startsWith';

import type {Properties} from 'nutshell-core/schema/schema-types';
import type {ListItem, FormattedValue} from 'nutshell-core/types';
import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import {EntityListMiniColumn} from './entity-list-mini-column';
import {EntityListMiniEmptyState} from './entity-list-mini-empty-state';

import styles from './entity-list-mini.module.css';

type Props = {
    schema: Properties;
    meta: {
        count: number;
        stats: {
            value: {
                sum: FormattedValue;
            };
        };
    };
    columns: string[];
    sortField: string;
    listItems: ListItem[];
    columnLimit: number;
    htmlUrl: string;
    type: string;
};

export class EntityListMini extends React.Component<Props> {
    render() {
        return (
            <React.Fragment>
                {this.props.listItems &&
                this.props.listItems.length &&
                this.props.columns &&
                this.props.columns.length ? (
                    <div className={styles['column-container']}>{this.renderColumns()}</div>
                ) : (
                    <EntityListMiniEmptyState
                        isHotLeadsList={Boolean(
                            this.props.htmlUrl &&
                                this.props.htmlUrl.includes('list=1000072-filters')
                        )}
                        hasError={!this.props.listItems}
                    />
                )}
                {this.props.listItems ? this.renderListFooter() : undefined}
            </React.Fragment>
        );
    }

    renderColumns() {
        const columnNames = _.first(this.props.columns, this.props.columnLimit);

        // Manually add phone number for people lists
        if (this.props.type === 'contacts') {
            columnNames.push('phone');
        }

        const columnFields = columnNames.map((columnName) => {
            const columnField = {...this.props.schema[columnName]} as const;

            // Attach the columnName to the field, since it's not on there
            // @ts-expect-error
            columnField.name = columnName;

            return columnField;
        });

        const isSortDescending = startsWith(this.props.sortField, '-');
        const sortField =
            isSortDescending && this.props.sortField
                ? this.props.sortField.substring(1, this.props.sortField.length - 1)
                : this.props.sortField;

        return columnFields.map((columnField) => {
            const columnData = this.props.listItems.map((item) => {
                // @ts-expect-error
                if (columnField.name === 'name' || columnField.name === 'leadDetails') {
                    return item;
                }

                // @ts-expect-error
                return item.fields[columnField.name];
            });

            return (
                <EntityListMiniColumn
                    // @ts-expect-error
                    key={`${columnField.name}`}
                    isLoading={false}
                    // @ts-expect-error
                    isSorting={sortField === columnField.name}
                    type={this.props.type}
                    sortDirection={isSortDescending ? 'descending' : 'ascending'}
                    columnData={columnData}
                    // @ts-expect-error
                    columnField={columnField}
                />
            );
        });
    }

    renderListFooter() {
        const {meta, type} = this.props;

        return (
            <div className={styles.footer}>
                {/* @ts-expect-error */}
                <Link to={this.props.htmlUrl} className={styles['more-link']}>
                    View list
                </Link>
                {meta && meta.count ? (
                    <div className={styles.count}>
                        <span>
                            &nbsp;of&nbsp;
                            {`${meta.count.toLocaleString()} ${getMultipleEntityType(type)}`}
                        </span>
                        {type === 'leads' && get(meta, 'stats.value.sum') ? (
                            <span>
                                &nbsp;valued at&nbsp;
                                <span>
                                    <span>{meta.stats.value.sum.prefix}</span>
                                    <span>{meta.stats.value.sum.formatted}</span>
                                    <span>{meta.stats.value.sum.suffix}</span>
                                </span>
                            </span>
                        ) : undefined}
                    </div>
                ) : undefined}
            </div>
        );
    }
}
